module.exports = __webpack_public_path__ + "9ebe47ebe8928cd80ea971f6cc7a2760.svg";